<template>
  <div>
    <Header />
    <div class="content-web container mt-5">
      <!-- Filter -->
      <div class="col-12 search-box mb-5 clearfix" id="search">
        <div class="row">
          <div class="col-12">
            <label class="title">Bộ lọc:</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12 d-flex mr-2 mb-2">
            <input
              v-model="searchForm.title"
              class="form-control mr-2 mb-2"
              type="text"
              placeholder="Tiêu đề"
              v-on:keyup.enter="searchSubmission(true)"
            />
            <input
              v-model="searchForm.author"
              class="form-control mr-2 mb-2"
              type="text"
              placeholder="Tác giả"
              v-on:keyup.enter="searchSubmission(true)"
            />
            <input
              v-model="searchForm.contactEmail"
              class="form-control mr-2 mb-2"
              type="text"
              placeholder="Email"
              v-on:keyup.enter="searchSubmission(true)"
            />             
            <v-select
              class="v-select-option mr-2 mb-2"
              label="name"
              placeholder="Lĩnh vực: Tất cả"
              :options="listType"
              v-model="searchForm.type"
              :reduce="p => p.code"
            ></v-select>
            <v-select
              class="v-select-option mr-2 mb-2"
              label="name"
              placeholder="CTTV: Tất cả"
              :options="companys"
              :reduce="p => p.code"
              v-model="searchForm.companyCode"
            ></v-select>
            <v-select
              class="v-select-option mr-2 mb-2"
              label="name"
              placeholder="Trạng thái: Tất cả"
              :options="listStatus"
              :reduce="obj => obj.code"
              v-model="searchForm.status"
            ></v-select>

            <div>
              <button class="btn btn_control mr-1 mb-2" v-on:click="searchSubmission(true)">Tìm kiếm</button>
              <button type="submit" class="btn btn_control mr-1 mb-2" v-on:click="clearSearch()">Xóa</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div class="table-box list-grid mb-5" v-if="loading">
        <div class="text-center">
          <div class="spinner-border text-dark" role="status">
            <span class="sr-only">Đang tải...</span>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div v-else class="table-box list-grid mb-5">
        <div class="title">
          <h6>DÁNH SÁCH ĐĂNG KÍ DỰ THI THÁNG</h6>
        </div>
        <div class="content-table">
          <table class="table table-hover table-md" style="overflow: inherit; table-layout: fixed;">
            <thead>
              <tr style=" text-align:top;">
                <th style="width: 60px;">ID</th>
                <th style="width: 180px;">TIÊU ĐỀ</th>
                <th style="width: 200px;">GIỚI THIỆU NGẮN GỌN</th>
                <th style="width: 120px;">LĨNH VỰC</th>
                <th style="width: 150px;">TÁC GIẢ/ NHÓM TÁC GIẢ</th>
                <th style="width: 100px;">THỜI GIAN ĐK</th>
                <th style="width: 120px;">CTTV</th>
                <th style="width: 130px;">LOẠI HIỆU QUẢ</th>
                <th style="width: 130px;">ƯỚC TÍNH HIỆU QUẢ</th>
                <th style="width: 130px;">THƯỞNG SÁNG KIẾN</th>
                <th style="width: 120px;">Thao tác</th>
              </tr>
            </thead>
            <tbody>
              <tr class="cell" v-for="item in submission" v-bind:key="item.id">
                <td>{{item.id}}</td>
                <td style="word-break: break-word;">
                  <a v-bind:href="`${ipDetailUrl}/${item.id}`">{{item.title}}</a>
                </td>
                <td>{{item.summary}}</td>
                <td>{{getTypeName(item.type)}}</td>
                <td>{{item.author}}</td>
                <td>{{item.createdTime | date}}</td>
                <td>{{item.companyName}}</td>
                <td>{{item.effectiveType}}</td>
                <td>{{item.effectiveEstimate | moneyFormat}}</td>
                <td>
                  <p>Công ty : {{item.bonusMoney | moneyFormat}}</p>
                  <p>Tập đoàn: {{item.groupBonusMoney | moneyFormat}}</p>
                </td>
                <td class="text-right">
                  <div class="dropdown">
                    <button
                      class="dropbtn dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Hành động
                      <span class="caret"></span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a
                        v-for="(action, index) in actions"
                        class="dropdown-item"
                        href="javascript:void(0)"
                        @click="processIdea(action.action, undefined, item.id)"
                        :key="index"
                      >{{action.actionName}}</a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mt-4 pagination">
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
            <span
              v-if="((pageSize*pageIndex)>total&&total!=0)"
            >{{pageSize*(pageIndex-1)+1}}-{{total}} của {{total}}</span>
            <span
              v-if="((pageSize*pageIndex)<=total)&&total!=0"
            >{{pageSize*(pageIndex-1)+1}}-{{pageSize*pageIndex}} của {{total}}</span>
            <span v-if="total==0">0-0 của 0</span>
          </div>
          <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex">
            <b-pagination
              v-if="total > pageSize"
              v-model="pageIndex"
              pills
              :total-rows="total"
              :per-page="pageSize"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <b-modal ref="chooseToContest" hide-footer title="Chọn vào chung khảo tháng">
      <div class="d-block">
        <validation-observer ref="formChooseToContest">
          <form>
            <validation-provider :rules="{ required: true}" v-slot="validationContext">
              <div class="form-group">
                <label class="required">Tháng</label>
                <b-form-select
                  v-model="ideaPeriodForm.periodCode"
                  :options="listPeriod"
                  value-field="code"
                  text-field="name"
                  :state="getValidationState(validationContext)"
                ></b-form-select>
                <b-form-invalid-feedback id="input-companyCode">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </div>
            </validation-provider>
          </form>
        </validation-observer>
      </div>
      <div style="float: right;">
        <button class="btn btn-info" @click="processIdea('add_to_period', 'submit', selectedId)">Gửi</button>
        <button class="btn btn-secondary" @click="processIdea('add_to_period', 'close', selectedId)">Đóng</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "../../config/index";
import moment from "moment";

import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { BPagination } from "bootstrap-vue";

import MasterDataCommon from "../../common/masterData";
import IdeaCommon from "../../common/idea";
import CompanyCommon from "../../common/company";
import periodCommon from "../../common/period";
import ideaWorkflow from '../../common/ideaWorkflow'
import ideaCommon from '../../common/idea'
import ideaScoringCommon from '../../common/ideaScoring'
import helper from '../../common/helper'
import ideaWorkflowCommon from '../../common/ideaWorkflow'

const defaultSearchForm = {
  title: "",
  author: "",
  contactEmail :"",
  createdBy: "",
  companyCode: "",
  status: ""
};
export default {
  name: "IdeasContest",
  components: {
    Header,
    Footer,
    "b-pagination": BPagination,
    DatePicker
  },
  data() {
    return {
      ipDetailUrl: `${CONFIG.CLIENT_URL}/#/admin/ip-view`,
      loading: false,
      searchForm: { ...defaultSearchForm },
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      listStatus: [],
      listType: [],
      submission: [],
      companys: [],
      actions: [],
      ideaPeriodForm: {},
      listPeriod: [],
      selectedId: null
    };
  },
  filters: {
    date: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    moneyFormat(value){
      if (value === 0 ) {
        return "0";
      }
      if(!value){
        return "";
      }
      return value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    }
  },
  methods: {
    async fetchData() {
      Promise.all([
        MasterDataCommon.sync.getByTypeAndCodeIn("idea_status", [
          "publish",
          "idea_contest",
          "scored"
        ]),
        MasterDataCommon.sync.getByType("idea_type"),
        CompanyCommon.getAll()
      ]).then(res => {
        this.listStatus = res[0];
        this.listType = res[1];
        this.companys = res[2];
      });
    },
    clearSearch() {
      this.clearFilterSearch();
      this.searchSubmission(true);
    },
    clearFilterSearch() {
      this.searchForm = { ...defaultSearchForm };
    },
    searchSubmission(isFirstPage) {
      this.loading = true;
      if (isFirstPage) {
        this.pageIndex = 1;
      }

      IdeaCommon.searchReviewIdeaToIKhien(
        this.searchForm,
        this.pageIndex,
        this.pageSize
      )
        .then(res => {
          this.submission = res.items;
          this.total = res.totals;
          this.loading = false;
        })
        .catch(error => {
          this.submission = [];
          this.total = 0;
          this.loading = false;
        });
    },
    getTypeName(code) {
      if (!code) {
        return "";
      }
      const typeData = this.listType.find(p => p.code === code);
      if (typeData) {
        return typeData.name;
      }
      return "";
    },
    async processIdea(action, subAction, id) {
      let submit = false;
      this.selectedId = id;
      const form = {
        ideaId: this.selectedId,
        action: action,
        data: {}
      };
      let mesage = "";
      if ("add_to_period" === action) {
        if (!subAction) {
          this.$refs.chooseToContest.show();
        } else {
          if (subAction === "submit") {
            const validate = await this.$refs.formChooseToContest.validate();
            if (validate) {
              this.ideaPeriodForm.ideaId = this.selectedId;
              form.data = this.ideaPeriodForm;
              submit = true;
              mesage = "Đã chọn chung khảo tháng thành công";
            } else {
              return;
            }
          } else {
            this.ideaPeriodForm = {
              periodCode: null
            };
            this.$refs.chooseToContest.hide();
          }
        }
        this.$refs.chooseToContest.hide();
      }
      if (submit) {
        let res = await ideaCommon.processIdea(form);
        if (res) {
          helper.successMsg(mesage);
        }
        await this.searchSubmission(false);
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    }
  },
  async created() {
    await this.fetchData();
    this.actions = await ideaWorkflow.getAction('publish');
    this.searchSubmission(true);
    const periodRes = await periodCommon.search("", 1, 1000, true);
    this.listPeriod = periodRes.items;
  },
  async mounted() {}
};
</script>

<style scoped>
@import "../../assets/css/filter_customs.css";
@import "../../assets/css/table_customs.css";
</style>




// WEBPACK FOOTER //
// src/components/pages/IdeasContest.vue